// cSpell:ignore xyflow
import { type ReactNode } from "react";
import type { ElkDirection } from "./hooks/useElkLayout";
import { DiagramDirectionContext } from "./_diagramDirectionContext";

export function DiagramDirectionProvider({
  value,
  children,
}: {
  value: ElkDirection;
  children: ReactNode;
}) {
  return (
    <DiagramDirectionContext.Provider value={value}>
      {children}
    </DiagramDirectionContext.Provider>
  );
}
